<div class="video-player-container">
  <div class="video-wrapper">
    <video
      #videoElement
      [src]="config.url"
      playsinline
      disablePictureInPicture
      controlsList="nodownload noplaybackrate"
      (click)="togglePlay()"
    ></video>

    <!-- Play overlay when paused -->
    <div
      class="play-overlay"
      *ngIf="!isPlaying && !completed"
      (click)="togglePlay()"
    >
      <mat-icon class="play-icon">play_circle_filled</mat-icon>
    </div>
  </div>

  <!-- Custom controls -->
  <div class="video-controls">
    <button
      mat-icon-button
      class="control-btn"
      (click)="togglePlay()"
      [disabled]="completed"
    >
      <mat-icon>{{ isPlaying ? 'pause' : (completed ? 'check_circle' : 'play_arrow') }}</mat-icon>
    </button>

    <!-- Progress bar (read-only, no seeking allowed) -->
    <div class="progress-bar-container">
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="progress"></div>
      </div>
    </div>

    <span class="time-display">
      {{ formatTime(currentTime) }} / {{ formatTime(duration) }}
    </span>

    <button
      mat-button
      class="control-btn speed-btn"
      (click)="cyclePlaybackRate()"
      aria-label="Playback speed"
    >
      {{ playbackRate }}x
    </button>

    <button
      mat-icon-button
      class="control-btn"
      (click)="toggleMute()"
    >
      <mat-icon>{{ isMuted ? 'volume_off' : 'volume_up' }}</mat-icon>
    </button>
  </div>
</div>
